$(function() {

	$.fn.select2.amd.require(['select2/selection/search'], function (Search) {
	    Search.prototype.searchRemoveChoice = function (decorated, item) {
	        this.trigger('unselect', {
	            data: item
	        });

	        this.$search.val('');
	        this.handleSearch();
	    };
	}, null, true);

	window.serendis.initSelect2 = function() {

		$('select.select:visible').not('initted').each(function() {

			var options = {};

			if ($(this).attr('data-url')) {
				var options = {
					ajax: {
						url: window.serendis.url + $(this).attr('data-url'),
						dataType: 'json'
					}
				};
			}

			$(this).select2(options).on('select2:unselecting', function(e) {
			    $(this).data('state', 'unselected');
			}).on('select2:unselecting', function() {
			    $(this).data('unselecting', true);
			}).on('select2:opening', function(e) {
			    if ($(this).data('unselecting')) {
			        $(this).removeData('unselecting');
			        e.preventDefault();
			    }
			});

			$(this).addClass('initted');

		});

	}

	window.serendis.initSelect2();

});